export const isWindows = () => {
  const platform =
    window?.navigator?.userAgentData?.platform ||
    window?.navigator?.platform ||
    false;
  if (!platform || typeof platform !== 'string') return false;
  return platform.toLowerCase().indexOf('win') === 0;
};
